<template>
  <v-dialog :model-value="value" width="500px" @keydown.esc="cancel" @click:outside="cancel">
    <BaseDialogCard :title="tkey('modalTitle')" @close="cancel">
      <p>{{ tkey('warning') }}</p>

      <template #footer>
        <v-card-actions>
          <v-btn primary @click="cancel">
            {{ tkey('cancel') }}
          </v-btn>
          <v-btn secondary variant="flat" class="outlined-btn" @click="confirm">
            {{ tkey('confirm') }}
          </v-btn>
        </v-card-actions>
      </template>
    </BaseDialogCard>
  </v-dialog>
</template>

<script>
import { useInternationalization } from '@/composables/use-internationalization';

export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },

  setup() {
    const { tkey } = useInternationalization('unsavedDataModal');
    return { tkey };
  },

  methods: {
    confirm() {
      this.$emit('confirm');
    },
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  font-size: 1.3rem;
  padding-top: 20px;
}

:deep(.dialog-card__footer) {
  justify-content: flex-end;

  .v-card__actions {
    padding: 0;
  }
}
</style>
